import { CASES } from "../data/services";
import { Reveal, SectionHeading } from "../components/site/Reveal";
import { MagneticButton } from "../components/site/MagneticButton";
import { useCalendly } from "../components/site/CalendlyModal";

export default function ProyectosPage() {
  const { openCalendly } = useCalendly();
  return (
    <div data-testid="proyectos-page">
      <section className="pt-44 pb-20">
        <div className="mx-auto max-w-7xl px-6">
          <SectionHeading
            eyebrow="Proyectos"
            title={<>Casos que muestran <span className="text-gradient">cómo pensamos.</span></>}
            copy="Por confidencialidad, los detalles de proyectos reales se comparten en conversaciones directas. Estos casos conceptuales ilustran nuestro enfoque frente a problemas empresariales comunes."
            testId="proyectos-heading"
          />
        </div>
      </section>
      <section className="pb-28">
        <div className="mx-auto max-w-7xl px-6 grid gap-5 md:grid-cols-3">
          {CASES.map((c, i) => (
            <Reveal key={c.title} delay={i * 0.12}>
              <article className="flex h-full flex-col rounded-2xl border border-[var(--line)] bg-[var(--surface)]/60 p-8 transition-colors hover:border-[var(--green)]/40" data-testid={`proyecto-card-${i}`}>
                <span className="mono w-max rounded-full border border-[var(--cyan)]/30 px-3 py-1 text-[10px] tracking-[0.25em] uppercase text-[var(--cyan)]">Caso conceptual</span>
                <h2 className="mt-6 text-2xl font-bold tracking-tight">{c.title}</h2>
                <p className="mt-6 text-sm leading-relaxed text-[var(--muted)]">
                  <span className="mono block text-[10px] tracking-[0.25em] uppercase text-[var(--muted)]/70 mb-1.5">Problema</span>
                  {c.problem}
                </p>
                <p className="mt-4 text-sm leading-relaxed text-[var(--ink)]/85">
                  <span className="mono block text-[10px] tracking-[0.25em] uppercase text-[var(--green)] mb-1.5">Solución conceptual</span>
                  {c.solution}
                </p>
              </article>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2}>
          <div className="mx-auto max-w-7xl px-6 mt-16 text-center">
            <p className="text-[var(--muted)] mb-7">¿Quieres conocer cómo abordaríamos tu caso?</p>
            <MagneticButton onClick={openCalendly} testId="proyectos-cta">Agendar una reunión</MagneticButton>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
